import { CardType, CategoryType } from 'types/deck'

type CardAggrigator = { inDeck?: Record<string, CardType[]>; outOfDeck?: Record<string, CardType[]> }

const plurals: Record<string, string> = {
  Sorcery: 'Sorceries',
  Conspiracy: 'Conspiracies',
  Commander: 'Commander',
  Sideboard: 'Sideboard',
  Maybeboard: 'Maybeboard',
}

export function generateEdhrecText(
  cards: CardType[],
  categoryMap: Record<string, CategoryType>,
  deckName: string,
  useCategoryNames: boolean = false,
): string {
  const splitCategories: CardAggrigator = cards.reduce((acc, card) => {
    if (!acc.inDeck) acc.inDeck = {}
    if (!acc.outOfDeck) acc.outOfDeck = {}

    const primaryCategory = categoryMap[card.categories[0]]

    if (primaryCategory.isPremier) {
      if (acc.inDeck['Commander']) acc.inDeck['Commander'].push(card)
      else acc.inDeck['Commander'] = [card]
    } else if (primaryCategory.name !== 'Sideboard' && primaryCategory.includedInDeck) {
      const categoryName = useCategoryNames ? primaryCategory.name || card.typeCategory : card.typeCategory
      if (acc.inDeck[categoryName]) acc.inDeck[categoryName].push(card)
      else acc.inDeck[categoryName] = [card]
    } else if (primaryCategory.name === 'Sideboard') {
      if (acc.outOfDeck['Sideboard']) acc.outOfDeck['Sideboard'].push(card)
      else acc.outOfDeck['Sideboard'] = [card]
    } else if (!primaryCategory.includedInDeck) {
      if (acc.outOfDeck[primaryCategory.name]) acc.outOfDeck[primaryCategory.name].push(card)
      else acc.outOfDeck[primaryCategory.name] = [card]
    }

    return acc
  }, {} as CardAggrigator)

  const { inDeck: inDeckCategories = {}, outOfDeck: outOfDeckCategories = {} } = splitCategories

  let deckString = ''

  for (let category in inDeckCategories) {
    let categoryName = category

    // Skipping Land, do them at the end
    if (categoryName === 'Land') continue

    if (!useCategoryNames) categoryName = plurals[category] ? plurals[category] : category + 's'

    let categoryString = `[${categoryName}]\n`

    inDeckCategories[category].sort((cardA, cardB) => (cardA.name > cardB.name ? 1 : -1))
    inDeckCategories[category].forEach(card => (categoryString += `*${card.qty} ${card.name}\n`))

    categoryString += `[/${categoryName}]\n\n`

    if (category === 'Commander') deckString = categoryString + deckString
    else deckString += categoryString
  }

  // Lands manually always at the very end
  if (inDeckCategories.Land) {
    let categoryString = `[Lands]\n`

    inDeckCategories.Land.sort((cardA, cardB) => (cardA.name > cardB.name ? 1 : -1))
    inDeckCategories.Land.forEach(card => (categoryString += `*${card.qty} ${card.name}\n`))

    categoryString += `[/Lands]\n\n`

    deckString += categoryString
  }

  for (let category in outOfDeckCategories) {
    let categoryName = category

    if (!useCategoryNames) categoryName = plurals[category] ? plurals[category] : category + 's'

    let categoryString = `[${categoryName}]\n`

    outOfDeckCategories[category].sort((cardA, cardB) => (cardA.name > cardB.name ? 1 : -1))
    outOfDeckCategories[category].forEach(card => (categoryString += `*${card.qty} ${card.name}\n`))

    categoryString += `[/${categoryName}]\n\n`

    deckString += categoryString
  }

  const finalString = `[deck title=${deckName}]\n\n${deckString}[/deck]`

  return finalString
}
